export default __webpack_public_path__ + "static/media/AR_Grid.c7eeb9ae.png";